import { render, staticRenderFns } from "./ApprovedProfiles.vue?vue&type=template&id=777425ba&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports